import { useLanguage } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";

const UKFlag = () => (
  <svg width="20" height="15" viewBox="0 0 60 30" className="rounded-sm transition-all duration-300 group-hover:scale-110 group-hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.6)]">
    <clipPath id="uk">
      <path d="M0,0 v30 h60 v-30 z"/>
    </clipPath>
    <clipPath id="uk2">
      <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/>
    </clipPath>
    <g clipPath="url(#uk)">
      <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#uk2)" stroke="#C8102E" strokeWidth="4"/>
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
    </g>
  </svg>
);

const LTFlag = () => (
  <svg width="20" height="15" viewBox="0 0 60 30" className="rounded-sm transition-all duration-300 group-hover:scale-110 group-hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.6)]">
    <rect width="60" height="10" fill="#FDB913"/>
    <rect y="10" width="60" height="10" fill="#006A44"/>
    <rect y="20" width="60" height="10" fill="#C1272D"/>
  </svg>
);

export const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2 bg-card/50 backdrop-blur-sm border border-border/50 rounded-full p-1">
      <Globe className="w-4 h-4 ml-2 text-muted-foreground" />
      <button
        onClick={() => setLanguage("en")}
        className={`group px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-300 flex items-center gap-1.5 ${
          language === "en"
            ? "bg-primary text-primary-foreground shadow-lg shadow-primary/20"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        <UKFlag />
        EN
      </button>
      <button
        onClick={() => setLanguage("lt")}
        className={`group px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-300 flex items-center gap-1.5 ${
          language === "lt"
            ? "bg-primary text-primary-foreground shadow-lg shadow-primary/20"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        <LTFlag />
        LT
      </button>
    </div>
  );
};
